/**
 * Environment
 */
export const BASE_URL = `${process.env.REACT_APP_API_HOST}/bateria`
export const SHOW_LOGS = process.env.NODE_ENV === 'development'
